var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP200TipBoxOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 141,
    fill: "none",
    viewBox: "0 0 91 141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    d: "M3.977 19.153A5.013 5.013 0 0 1 8.99 14.14l72.273-.003a5.012 5.012 0 0 1 5.012 5.013l-.003 70.757a5.013 5.013 0 0 1-5.013 5.013l-72.273.003a5.012 5.012 0 0 1-5.012-5.013l.003-70.757z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeWidth: 2,
    d: "M4.98 19.153a4.01 4.01 0 0 1 4.01-4.01l72.273-.003a4.01 4.01 0 0 1 4.01 4.01l-.003 70.757a4.01 4.01 0 0 1-4.01 4.01l-72.274.003a4.01 4.01 0 0 1-4.01-4.01l.003-70.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    fillRule: "evenodd",
    d: "M8.967 16.16a3.008 3.008 0 0 0-3.008 3.008L5.957 87.89a5.012 5.012 0 0 0 5.012 5.012h4.903l.003-65.636c0-7.035 13.882-11.108 13.882-11.108H8.967z",
    clipRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    d: "M35.707 3.01A3.008 3.008 0 0 1 38.715.002h11.832a3.007 3.007 0 0 1 3.008 3.007v11.13H35.705V3.01z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 3.022,
    fill: "#E5ECF0",
    rx: 1.511,
    transform: "matrix(1.00257 -.00004 -.00004 1.00257 37.69 4.041)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5ECF0",
    fillRule: "evenodd",
    d: "M82.287 16.157c1.107 0 2.005.898 2.005 2.005l-.003 70.735a5.013 5.013 0 0 1-5.013 5.013h-4.902l.002-66.645c0-7.035-13.881-11.107-13.881-11.107h13.882l3.966-.001h3.944z",
    clipRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M20.974 75.503l8.52.047-.009 1.723-8.52-.047.009-1.723z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 9,
    height: 56,
    x: 21,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M21.4 75.505l7.669.043-.506 14.644-.468-.003-.427 7.752-.459-.002-1.424 32.736-1.704-.012-1.067-32.747-.459-.003-.34-7.756-.47-.003-.345-14.649z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M20.974 75.526h8.521l-.474 14.647h-7.574l-.473-14.647z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M20.973 89.311h8.522l-.231 8.616h-8.06l-.23-8.616z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M22.677 97.066h5.113l-1.706 33.601H24.38l-1.703-33.601z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M24.507 130.666l-1.403-54.278H21.4l-.728 54.264 3.835.014zM25.359 130.666l2.006-54.278h1.704l.125 54.299-3.835-.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M29.486 77.273l-8.521-.046.005.884 8.51.023.006-.861zm-8.383 12.9h7.54l-.027.861h-7.643l.13-.86zm1.66 7.755h4.942l-.017.86h-5.01l.085-.86z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M56.405 75.502l8.521.047-.01 1.723-8.52-.047.01-1.723z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 9,
    height: 56,
    x: 56,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M56.831 75.504l7.67.042-.507 14.645-.468-.003-.426 7.752-.46-.003-1.423 32.737-1.705-.013-1.066-32.747-.459-.002-.34-7.756-.47-.003-.346-14.65z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M56.406 75.525h8.52l-.473 14.646h-7.575l-.472-14.646z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M56.405 89.31h8.521l-.23 8.616h-8.061l-.23-8.616z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M58.109 97.064h5.113l-1.706 33.602h-1.704l-1.703-33.602z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M59.938 130.664l-1.402-54.278H56.83l-.727 54.264 3.834.014zM60.79 130.664l2.006-54.278h1.705l.124 54.299-3.834-.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M64.917 77.272l-8.52-.047.004.885 8.511.023.005-.861zm-8.382 12.9h7.54l-.027.86-7.643.001.13-.86zm1.66 7.754h4.941l-.017.861h-5.01l.085-.86z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M39.549 75.502l8.52.047-.009 1.723-8.52-.047.009-1.723z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 9,
    height: 56,
    x: 39,
    y: 75,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M39.975 75.504l7.669.043-.506 14.644-.468-.002-.427 7.752-.459-.003-1.424 32.736-1.704-.012-1.066-32.747-.46-.003-.34-7.756-.469-.002-.346-14.65z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M39.55 75.525h8.52l-.474 14.647h-7.574l-.473-14.647z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M39.549 89.31h8.52l-.23 8.616h-8.06l-.23-8.615z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M41.252 97.065h5.113l-1.706 33.602h-1.704l-1.703-33.602z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M43.082 130.665l-1.403-54.278h-1.704l-.727 54.264 3.834.014zM43.934 130.665l2.006-54.278h1.704l.125 54.299-3.835-.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M48.061 77.272l-8.521-.046.005.884 8.511.023.005-.86zm-8.382 12.9h7.539l-.026.861-7.643.001.13-.861zm1.659 7.755h4.942l-.017.86-5.01.001.085-.861z",
    clipRule: "evenodd",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M24.94 73.499l9.296.05-.01 1.88-9.296-.05.01-1.88z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 9,
    height: 61,
    x: 25,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M25.406 73.501l8.366.046-.552 15.976-.51-.003-.466 8.457-.5-.003-1.555 35.712-1.859-.013-1.163-35.724-.5-.003-.373-8.461-.51-.003-.378-15.981z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M24.94 73.524h9.297l-.517 15.978h-8.263l-.516-15.978z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M24.94 88.562h9.296l-.251 9.399H25.19l-.25-9.399z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M26.8 97.022h5.577l-1.861 36.656h-1.86L26.8 97.022z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M28.795 133.676l-1.53-59.212h-1.86l-.793 59.197 4.183.015zM29.725 133.676l2.188-59.213h1.859l.136 59.236-4.183-.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M34.226 75.43l-9.295-.051.005.965 9.285.025.005-.94zm-9.144 14.073l8.224-.001-.028.94H24.94l.142-.94zm1.81 8.459h5.392l-.019.939h-5.466l.093-.94z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M43.516 73.498l9.296.051-.01 1.88-9.296-.051.01-1.88z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 10,
    height: 61,
    x: 43,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M43.981 73.5l8.366.046-.552 15.976-.51-.003-.466 8.457-.5-.003-1.554 35.713-1.86-.014-1.163-35.724-.5-.003-.372-8.461-.511-.003-.378-15.98z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M43.516 73.523h9.296L52.295 89.5h-8.263l-.516-15.978z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M43.516 88.562h9.296l-.252 9.398h-8.793l-.251-9.398z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M45.375 97.02h5.577l-1.86 36.657h-1.86l-1.857-36.656z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M47.37 133.675l-1.53-59.212h-1.859l-.794 59.197 4.183.015zM48.3 133.675l2.188-59.212h1.86l.135 59.235-4.183-.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M52.802 75.429l-9.296-.051.005.965 9.285.025.006-.94zm-9.145 14.073h8.225l-.029.939h-8.337l.142-.939zm1.81 8.459h5.392l-.019.939h-5.466l.093-.94z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M61.1 73.497l9.295.051-.01 1.88-9.296-.051.01-1.88z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 9,
    height: 61,
    x: 61,
    y: 73,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M61.565 73.5l8.366.046-.552 15.975-.51-.002-.466 8.456-.5-.003-1.555 35.713-1.859-.014-1.163-35.724-.5-.003-.373-8.46-.51-.004-.378-15.98z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M61.1 73.522h9.296L69.879 89.5h-8.263L61.1 73.523z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M61.1 88.56h9.295l-.251 9.4H61.35l-.25-9.4z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M62.958 97.02h5.578l-1.861 36.656h-1.86L62.959 97.02z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M64.954 133.674l-1.53-59.212h-1.86l-.793 59.197 4.183.015zM65.884 133.674l2.188-59.212h1.86l.135 59.235-4.183-.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M70.385 75.428l-9.295-.05.005.964 9.285.025.005-.94zM61.241 89.5h8.225l-.029.939H61.1l.142-.939zm1.81 8.46l5.392-.001-.019.94h-5.466l.093-.94z",
    clipRule: "evenodd",
    opacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M11.905 70.491l9.915.055-.01 2.036-9.916-.054.011-2.037z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 10,
    height: 66,
    x: 12,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M12.4 70.494l8.925.049-.59 17.307-.545-.003-.497 9.161-.534-.002-1.66 38.688-1.984-.014-1.238-38.701-.534-.003-.396-9.167-.545-.003-.401-17.312z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M11.905 70.519l9.916-.002-.553 17.31-8.814.001-.549-17.31z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M11.903 86.81l9.916-.001-.27 10.182-9.379.002-.267-10.183z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M13.885 95.974h5.95l-1.989 39.711h-1.983l-1.978-39.71z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M16.01 135.683l-1.626-64.146h-1.983l-.852 64.13 4.462.016zM17.002 135.683l2.34-64.147h1.983l.14 64.171-4.463-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M21.81 72.582l-9.916-.053.006 1.044 9.904.026.006-1.017zM12.054 87.83l8.773-.003-.03 1.017-8.894.003.151-1.017zm1.93 9.163l5.751-.001-.02 1.017-5.83.002.1-1.018z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M30.745 70.49l9.915.055-.011 2.036-9.916-.054.012-2.037z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 10,
    height: 66,
    x: 31,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M31.24 70.493l8.924.05-.59 17.306-.545-.003-.497 9.161-.534-.002-1.66 38.688-1.983-.014-1.238-38.701-.534-.003-.396-9.167-.545-.003-.401-17.312z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M30.745 70.518l9.915-.002-.553 17.31-8.813.002-.55-17.31z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M30.743 86.81l9.915-.002-.269 10.182-9.38.002-.266-10.183z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M32.725 95.973h5.95l-1.989 39.711h-1.983l-1.978-39.71z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M34.85 135.682l-1.626-64.146H31.24l-.852 64.13 4.461.016zM35.842 135.682l2.34-64.147h1.982l.14 64.172-4.462-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M40.65 72.581l-9.916-.053.005 1.044 9.904.026.006-1.017zM30.893 87.83l8.773-.002-.03 1.017-8.895.002.152-1.017zm1.93 9.163l5.751-.001-.02 1.017-5.83.002.099-1.018z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M48.593 70.49l9.915.054-.011 2.037-9.916-.055.012-2.036z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 10,
    height: 66,
    x: 49,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M49.089 70.492l8.923.05-.59 17.306-.545-.003-.497 9.162-.534-.003-1.66 38.688-1.983-.014-1.238-38.701-.534-.003-.396-9.166-.545-.003-.401-17.313z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M48.593 70.517l9.915-.001-.553 17.31h-8.813l-.55-17.31z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M48.59 86.809l9.916-.002-.269 10.183-9.38.001-.266-10.182z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M50.573 95.972h5.949l-1.988 39.711h-1.983l-1.978-39.71z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M52.698 135.681l-1.626-64.146h-1.983l-.852 64.13 4.461.016zM53.69 135.681l2.34-64.147h1.982l.14 64.172-4.462-.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M58.497 72.58l-9.915-.053.005 1.045 9.904.025.006-1.016zm-9.755 15.248l8.773-.002-.03 1.017-8.895.002.152-1.017zm1.93 9.164l5.751-.002-.02 1.017-5.83.002.099-1.017z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M67.432 70.489l9.915.054-.01 2.037-9.916-.055.01-2.036z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 10,
    height: 66,
    x: 67,
    y: 70,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    fillRule: "evenodd",
    d: "M67.928 70.491l8.924.05-.59 17.307-.545-.003-.498 9.161-.533-.003-1.661 38.689-1.983-.015-1.238-38.7-.534-.004-.396-9.166-.545-.003-.401-17.313z",
    clipRule: "evenodd",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M67.432 70.516l9.916-.001-.553 17.31-8.814.001-.549-17.31z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M67.43 86.808l9.916-.001-.27 10.182-9.38.001-.266-10.182z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M69.412 95.972l5.95-.001-1.989 39.711-1.983.001-1.978-39.711z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFC7",
    d: "M71.537 135.681l-1.626-64.147h-1.983l-.852 64.131 4.462.016zM72.53 135.681l2.339-64.148h1.983l.14 64.172-4.463-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M77.337 72.58l-9.916-.053.006 1.044 9.904.026.006-1.017zM67.58 87.828l8.773-.003-.03 1.017-8.894.002.151-1.016zm1.93 9.163l5.751-.002-.02 1.018-5.83.001.1-1.017z",
    clipRule: "evenodd",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#B0E298",
    fillRule: "evenodd",
    d: "M8.954 86.845a2.005 2.005 0 0 0-2.006 2.005v7.083H3.004a2.005 2.005 0 0 0-2.005 2.005v2.034h5.949v.014c0 1.108.898 2.005 2.005 2.005l71.348-.003a2.005 2.005 0 0 0 2.005-2.005v-.014h6.94v-2.035a2.005 2.005 0 0 0-2.004-2.005h-4.936v-7.082a2.005 2.005 0 0 0-2.005-2.005l-71.347.003z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BB975",
    fillRule: "evenodd",
    d: "M79.331 95.93l-69.408.003H6.948V88.85c0-1.108.898-2.005 2.006-2.005h.97l-.001 5.048 69.409-.002v-5.05h.97c1.107 0 2.004.898 2.004 2.006v7.083H79.331zM1 97.938c0-1.107.898-2.005 2.005-2.005h.97v4.039H.998v-2.034zm86.243-2.009h-.97v4.04h2.975v-2.035a2.005 2.005 0 0 0-2.005-2.005z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    d: "M86.048 102.489c-.12.347-.277.827-.459 1.449-.423 1.445-.985 3.655-1.546 6.733-1.108 6.08-2.213 15.546-2.24 29.188h-11.3l-2.387-.972-.091-.037h-.098l-46.603.001h-.099l-.09.037-2.388.973-10.308.001c-.024-13.391-1.005-22.851-1.988-28.988-.498-3.107-.997-5.362-1.372-6.844a38.217 38.217 0 0 0-.42-1.537l81.389-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeWidth: 2,
    d: "M3.973 100.982s3.966 11.107 3.965 38.371h10.907l2.479-1.01 46.603-.002 2.478 1.01 11.9-.001c0-27.769 3.967-38.372 3.967-38.372"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5ECF0",
    d: "M.999 99.972l88.248-.004a2.02 2.02 0 0 1-2.02 2.02l-84.209.004a2.02 2.02 0 0 1-2.02-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5ECF0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M68.422 138.341l.001-17.069c0-5.146-6.671-13.224-23.574-13.223-16.903 0-24.02 8.079-24.02 13.225l-.001 17.069"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.78,
    height: 6.043,
    fill: "#F5F7F9",
    opacity: 0.6,
    rx: 1,
    transform: "matrix(1.00257 -.00004 -.00004 1.00257 34.711 105.02)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h90v140H0z",
    transform: "matrix(1.00257 -.00004 -.00004 1.00257 .011 .004)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 20.974 75.503)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 56.406 75.502)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8.499v55H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 39.55 75.502)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 24.94 73.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 43.516 73.498)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.272v60H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 61.1 73.497)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 11.905 70.491)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 30.745 70.49)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 48.593 70.49)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9.89v65H0z",
    transform: "matrix(1.00255 .00552 -.00548 1.00255 67.432 70.489)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP200TipBoxOpen);
export default __webpack_public_path__ + "static/media/p200-tip-box-open.0c96867d976b63b76ff156a872db0a1a.svg";
export { ForwardRef as ReactComponent };